import { PropsWithChildren } from 'react';
import clsx from 'clsx';
import { VisibilityOutlined } from '@material-ui/icons';

interface AppViewOptionProps {
  onClick(): void;
  selected: boolean;
}

export const AppViewOption = ({
  children,
  onClick,
  selected,
}: PropsWithChildren<AppViewOptionProps>) => {
  return (
    <li className="w-full">
      <button
        className={clsx(
          'flex items-center justify-between gap-3 hover:bg-primary/10 rounded px-3 py-2 w-full',
          { 'text-primary': selected }
        )}
        onClick={onClick}
      >
        {children}
        {selected && <VisibilityOutlined className="!h-4 !w-auto" />}
      </button>
    </li>
  );
};
